'use strict';

goog.provide("Ntry.CpartyIntro");

Ntry.CpartyIntro = function() {
    this._view = Ntry.interfaceManager.getDom('ntryIntroArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryIntroContainer');
        var title = Ntry.createElement('div', container, null, 'ntryIntroTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryIntroCloseButton');
        this._closeButton.innerHTML = Lang.Menus.close;

        var content = Ntry.createElement('div', container, null, 'ntryIntroContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryIntroLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryIntroRightDiv');
        this._rightTop = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightTop');
        this._rightCenter = Ntry.createElement('div', rightDiv, null, 'ntryIntroRightCenter');

        this._startButton = Ntry.createElement('span', content, null, 'ntryIntroStartButton');
        this._startButton.innerHTML = Lang.Menus.start;

        this._view.bindOnClick(function(e) {
            if (e.target == this)
                $(parent).css('display', 'none');
        });
    };

    p.update = function() {
    };

    p.loadConfig = function () {
        this._intro = Ntry.configManager.getConfig('intro');
        if (this._intro)
            this.fillContent();
    };

    p.fillContent = function() {
        var intro = this._intro;
        var stageId = Ntry.configManager.getConfig("stageId");

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryIntroLeftImg');

        if (stageId <= 10)
            this._leftImg.addClass('cpartyIntroLeft1Img');
        else if (stageId <= 20)
            this._leftImg.addClass('cpartyIntroLeft2Img');

        if (stageId/10 && stageId%10==0)
            this._rightTop.innerHTML = 10 + '/10';
        else
            this._rightTop.innerHTML = stageId%10 + '/10';

        this._rightCenter.innerHTML = intro.content;

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._startButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        $(this._view).css('display', 'block');


    };


})(Ntry.CpartyIntro.prototype);
